import { useEffect, useRef, useState } from "react";
import { Checkbox, Col, Row, Input, message, Spin } from "antd";
import { useLocation } from "react-router";
import { BASE_DOWNLOAD_URL } from "../../../../utils/token";
import { formatFeedbackParam } from "../../../../utils";
import commonApi from "../../../../apis/commonApi";
import arrowPng from "./arrow.png";
import Upload from "./Upload";
import "./index.scss";

const { TextArea } = Input;

let curCheckboxList = null;

const FeedbackForm = ({
  detailInfo,
  setShowDetail,
  setTabKey,
  isView = false,
}) => {
  const { search } = useLocation();
  const [typeValue, setTypeValue] = useState([]);
  const [describe, setDescribe] = useState();
  const [loading, setLoading] = useState(false);
  // const [isView, setIsView] = useState(false);
  const [urlInfo, setUrlInfo] = useState({
    sys: "CRM",
  });
  const [defaultFileList, setDefaultFileList] = useState();

  const [checkboxList, setCheckboxList] = useState([]);
  // 成功提交页面
  const [isResult, setIsResult] = useState(false);

  const uploadRef = useRef();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const codeInfo = query.get("code");
    const _urlInfo = formatFeedbackParam(codeInfo);
    setUrlInfo(_urlInfo);
    if (curCheckboxList) {
      setCheckboxList(curCheckboxList);
      return;
    }
    // 默认CRM系统
    const curSys = _urlInfo?.sys || "CRM";
    commonApi
      .getDictionaryList({
        dictTypeCodeList: ["feedback_question_type"],
      })
      .then((res) => {
        const questionTypes = res?.feedback_question_type || [];
        const curQuestionTypes = questionTypes.find(
          (item) => item.dictCode === curSys
        );
        if (curQuestionTypes && curQuestionTypes.children) {
          curCheckboxList = curQuestionTypes.children;
          setCheckboxList(curQuestionTypes.children);
        }
      });
  }, [search]);

  // 查看详情
  useEffect(() => {
    if (detailInfo) {
      const { feedbackTypeCode, feedbackDescribe, sfaFeedbackFileEntity } =
        detailInfo;
      // setIsView(true);
      setTypeValue([feedbackTypeCode]);
      setDescribe(feedbackDescribe);
      if (sfaFeedbackFileEntity && sfaFeedbackFileEntity.length) {
        const _defaultFileList = sfaFeedbackFileEntity.map((item) => ({
          name: item.originalFileName,
          status: "done",
          url: `${BASE_DOWNLOAD_URL}${item.fileCode}.id`,
        }));
        setDefaultFileList(_defaultFileList);
      }
    }
  }, [detailInfo]);

  const checkParameter = () => {
    if (!urlInfo.userCode || !urlInfo.userName || !urlInfo.sysTerminal)
      return "用户信息获取失败，请关闭当前页面后重新进入再提交";
    if (!typeValue || !typeValue.length) return "请选择所要反馈的模块";
    if (!describe) return "请输入您的反馈意见";
    const fileList = uploadRef.current?.fileList;
    if (urlInfo.otherKey === "fileMust" && (!fileList || fileList.length === 0))
      return "附件不能为空，请至少提交一个附件";
    return "";
  };

  const onClickBtn = () => {
    // 返回
    if (isView && setShowDetail) {
      setShowDetail(false);
      return;
    }
    const errStr = checkParameter();
    if (errStr) {
      message.error(errStr);
      return;
    }
    const _curCode = typeValue[0];
    const _curCheckValue = checkboxList.find(
      (item) => item.dictCode === _curCode
    );
    setLoading(true);
    const fileList = uploadRef.current?.fileList;
    const sfaFeedbackFileEntity = [];
    if (fileList) {
      fileList.forEach((el) => {
        const result = el?.response?.data;
        if (result && result.length) {
          result.forEach((item) => {
            sfaFeedbackFileEntity.push({
              createTime: item.createTime,
              fileName: item.fileName,
              fileCode: item.id,
              modifyTime: item.modifyTime,
              originalFileName: item.originalFileName,
              relativeLocal: item.relativeLocal,
            });
          });
        }
      });
    }
    commonApi
      .createFeedback({
        feedbackSys: urlInfo.sys,
        submitUserCode: urlInfo.userCode,
        submitUserName: urlInfo.userName,
        feedbackSysTerminal: urlInfo.sysTerminal,
        feedbackTypeCode: _curCode,
        feedbackTypeName: _curCheckValue.dictValue,
        feedbackDescribe: describe,
        sfaFeedbackFileEntity,
      })
      .then((res) => {
        // 提交成功
        if (res) {
          document.getElementsByClassName("feedback-web-wrapper")[0]?.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          setIsResult(true);
        }
      })
      .catch((err) => {
        message.err(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeCheckbox = (checkedValues) => {
    const preVal = typeValue;
    // 不支持多选
    const newVal = checkedValues.filter((el) => el !== preVal[0]);
    if (newVal.length) {
      setTypeValue(newVal);
    }
  };

  const onChangeTextArea = (e) => {
    setDescribe(e.target.value);
  };

  const onListPage = () => {
    setTabKey && setTabKey(1);
  };

  return (
    <div className="feedback-form-wrapper">
      <Spin spinning={loading} fullscreen />
      {isResult ? (
        <div className="success-content">
          <img src={arrowPng} alt="" />
          <h2>意见反馈提交成功</h2>
          <p>您反馈的意见已提交，我们将尽快安排解决</p>
          <div className="btn" onClick={onListPage}>
            完成
          </div>
        </div>
      ) : (
        <>
          <div className="form-content">
            <div className="form-item-label required">反馈模块：</div>
            <Checkbox.Group
              className="type-wrapper"
              value={typeValue}
              onChange={onChangeCheckbox}
              disabled={isView}
            >
              <Row>
                {checkboxList.map((item) => (
                  <Col key={item.id} span={8} style={{ marginBottom: "5px" }}>
                    <Checkbox value={item.dictCode}>{item.dictValue}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
            <div className="form-item-label required">
              请详细描述您的反馈意见：
            </div>
            <TextArea
              disabled={isView}
              showCount
              maxLength={300}
              value={describe}
              onChange={onChangeTextArea}
              placeholder="请输入您的反馈意见"
              className="describe-input"
              autoSize={{
                minRows: 3,
                maxRows: 3,
              }}
            />
            <div
              className={`form-item-label ${
                urlInfo?.otherKey === "fileMust" ? "required" : "" // 附件必填
              }`}
            >
              {/* 补充上传截图或附件(最多5个，单个大小不超过10M)： */}
              补充上传截图或附件(仅支持excel、pdf、jpg、png、word文件，最多支持上传5个附件，且单个文件不得大于10M)：
            </div>
            <Upload
              ref={uploadRef}
              isView={isView}
              defaultFileList={defaultFileList}
            />
          </div>
          <div className="form-footer">
            <div className="btn" onClick={onClickBtn}>
              {isView ? "返回" : "提交"}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FeedbackForm;
